<template>
  <div class="container">
    <nav-box title="在住客登记" :back="true"></nav-box>
    <div class="content flex-column" @click="focusInput">
      
      <div v-if="room" class="room-data">
        <div class="room-info">
          <div class="room-info-row">
            <div><span class="room-info-label">房间号：</span>{{room.roomNo}}</div>
          </div>
          <div class="room-info-row">
            <div><span class="room-info-label">水疗人数：</span>{{room.wqPersons}}</div>
          </div>
          <div class="room-info-row">
            <div><span class="room-info-label">客人姓名：</span>{{room.guestCname}}</div>
          </div>
          <div class="room-info-row">
            <div><span class="room-info-label">抵店时间：</span>{{room.arrDate?room.arrDate:'--'}}</div>
          </div>
        </div>
      </div>
      <div class="code-box flex-column flex-center" v-else>
        <p class="tip">请在自助机刷房卡登记手牌</p>
        <div class="code">
          <img src="../../assets/swipe.png" alt="" />
        </div>
      </div>
      
    </div>

    <div class="form" v-if="room">
      <div class="form-content">

        <div class="guest-box flex-column">
          <p class="title">请选择人数</p>
          <div class="guest-sex flex-column">
            <div class="sex-item flex flex-sb">
              <div class="sex flex flex-center">
                <img src="@/assets/man.png" alt="" sizes="" srcset="" />
                <span>男宾</span>
              </div>
              <div class="num flex flex-center">
                <div class="minus flex" @click="minusNum('manQuantity')">
                  <img
                    src="@/assets/minus-icon.png"
                    v-if="manQuantity > 0"
                    alt=""
                  />
                  <img src="@/assets/minus-icon-disable.png" v-else alt="" />
                </div>
                <div class="number">
                  {{ manQuantity }}
                </div>
                <div class="add flex" @click="addNum('manQuantity')">
                  <img src="@/assets/add-icon.png" alt="" />
                </div>
              </div>
            </div>
            <div class="sex-item flex flex-sb">
              <div class="sex flex flex-center">
                <img src="@/assets/woman.png" alt="" sizes="" srcset="" />
                <span>女宾</span>
              </div>
              <div class="num flex flex-center">
                <div class="minus flex" @click="minusNum('femaleQuantity')">
                  <img
                    src="@/assets/minus-icon.png"
                    v-if="femaleQuantity > 0"
                    alt=""
                  />
                  <img src="@/assets/minus-icon-disable.png" v-else alt="" />
                </div>
                <div class="number">
                  {{ femaleQuantity }}
                </div>
                <div class="add flex" @click="addNum('femaleQuantity')">
                  <img src="@/assets/add-icon.png" alt="" />
                </div>
              </div>
            </div>
          </div>
          <div class="btn-group flex flex-sb">
            <div class="btn-item reset flex flex-center" @click="reset">
              重置
            </div>
            <div class="btn-item affirm flex flex-center" @click="submit">
              确认
            </div>
          </div>
        </div>

      </div>
      
    </div>


    <!-- 保存刷卡获取到的手牌号 -->
    <input type="text" ref="input" class="Key-card" focus v-model="KeyCard" @keyup.enter="swipingCard" />

  </div>
</template>

<script>
import navBox from "@/components/nav-box.vue";
import debounce from "@/utils/debounce.js";
import axios from "axios";

export default {
  components: {
    navBox,
  },
  name: "guestRegister",
  data() {
    return {
      KeyCard: "",//手牌号
      manQuantity:0,
      femaleQuantity:0,
      guestTypeId:'',//客人类型
      room:null,//在住客客房
      printRegistrOrder:1,//是否打印手牌登记单

    };
  },
  watch: {
    KeyCard: {
      handler: function (val, oldVal) {
        this.focusInput();
      },
      deep: true,
    },
  },
  created() {

    //定时设置输入框焦点
    this.focusInputInterval = setInterval(()=>{
      if(this.room==null){
        console.log('定时设置输入框焦点')
        this.focusInput();
      }
    }, 1000);
  },
  destroyed() {
    //清除定时设置输入框焦点
    if(this.focusInputInterval){
      clearInterval(this.focusInputInterval);
      this.focusInputInterval = null;
    }
  },
  mounted() {
    this.focusInput();
    this.getGuestType();
    // this.getPrintRegistrOrder()
  },
  methods: {
    //设置输入框焦点
    focusInput() {
      this.$refs.input.focus();
    },
    getPrintRegistrOrder() {
      this.$fetchNo(this.Api.getSettingCode + "/001003008").then((res) => {
        this.printRegistrOrder = parseInt(res.data.value)
      });
    },
    //刷卡
    swipingCard() {
      console.log(this.KeyCard)
      if (this.KeyCard) {

        this.loading = true;

        const roomCode = (this.KeyCard.length>7?"ACCID:":"")+this.KeyCard
        this.$fetchNo(this.Api.SingleRoomBill+roomCode, {}).then((res) => {
          if (res.data && res.data.length>0) {
            this.room = res.data[0]
          } else {
            this.$toast('找不到房卡、请重刷')
          }
        });
      
      }
      this.KeyCard = "";
      this.$refs.input.focus();
    },
    // 获取客人类型列表
    getGuestType() {
      this.$fetchNo(this.Api.GuestType, { status: 1 }).then((res) => {
        const guestTypes = res.data.items.filter(item=>item.additionalProperties==16);
        if(guestTypes.length>0){
          this.guestTypeId = guestTypes[0].id
        }
      });
    },
    // 数量减法
    minusNum(item) {
      if (item == "manQuantity") {
        if (this.manQuantity == 0) {
          this.manQuantity = 0;
        } else {
          this.manQuantity--;
        }
      } else {
        if (this.femaleQuantity == 0) {
          this.femaleQuantity = 0;
        } else {
          this.femaleQuantity--;
        }
      }
    },
    // 数量加法
    addNum(item) {
      if (item == "manQuantity") {
        this.manQuantity++;
      } else {
        this.femaleQuantity++;
      }
    },
    reset(){
      this.femaleQuantity=null;
      this.manQuantity=null
    },
    submit(){
      debounce(()=>{
        if (!this.femaleQuantity && !this.manQuantity) {
          this.$toast('请选择客人数量')
          return;
        }

        this.$toast.loading({
          message: "正在开牌中，请稍后....",
          forbidClick: true,
        });

        // 修改请求格式
        const data = {
          consumptionAreaId: localStorage.getItem("consumptionAreaId"),
          regId:this.room.regId,
          maxRegCount:this.room.wqPersons,
          roomNo:this.room.roomNo,
          items: [{
            femaleQuantity:this.femaleQuantity,
            manQuantity:this.manQuantity,
            guestTypeId:this.guestTypeId,
          }]
        };

        this.$post(this.Api.BatchManualOpen, data).then((res) => {
          this.$toast.clear();
          if (res.code == 1) {
            console.log(res)
            if(this.printRegistrOrder > 0){
              this.printEntrance(res.data.map(item=>({KeyNo:item,consumptionSubjectId:''})))
            }
          }
        });
      })
    },
    // 打印入场单
    async printEntrance(list) {
      if (this.printRegistrOrder > 0) {
        //获取打印报表
        let data = {
          // id:this.orderData.id,
          //type: this.printRegistrOrder>1?"P12":"P10",
          type: "P10",
        };
        let that = this;
        let printData = await this.requestUrlOrBody(data);

        axios.post(printData.requestUrl, 
          {
            consumptionSubjectIds:list.map(item => item.consumptionSubjectId).join(","),
            keyCards:list.map(item => item.KeyNo).join(",")
          }, {
          headers: {
            access_token: this.loginToken,
            x_req_application_id: 1,
            x_req_terminal: 9,
            x_req_store_id: localStorage.getItem("storeId"),
          },
        })
        .then(function (res) {
          // 打印一张入场单
          if(that.printRegistrOrder==2){
            that.dataSet(printData.body, res.data.data);
          }else{
            console.log('printEntrance res',res)
            // 打印多张入场单
            res.data.data.dataList.forEach((item, index) => {
              setTimeout(() => {
                that.dataSet(printData.body, [item]);
              }, 3000 * index); // 每隔1.5秒执行一次

              that.room = null
            });
          }
        })
        .catch(function (error) {
        });

      }
    },
    async requestUrlOrBody(data) {
      var requestData = {
        requestUrl: "",
        body: "",
      };
      let printData = await this.$fetchNo(
        this.Api.PrintReport + "/" + data.type
      );
      requestData.body = printData.data.body;
      requestData.requestUrl = printData.data.dataInterfaceUrl;
      let reportData = await this.$fetchNo(this.Api.ReportFormat, {
        reportId: printData.data.id,
      });
      if (reportData.data.items.length > 0) {
        let list = reportData.data.items.filter((item) => item.isDefault);
        if (list.length > 0) {
          requestData.body = list[0].body;
        }
      }
      return requestData;
    },
    dataSet(body, data) {
      this.load = false;
      var that = this;
      var num = data.printCount?data.printCount:0;
      var invoiceAddressValue = data.invoiceAddress?data.invoiceAddress:'';
      //创建报表对象
      var report = new window.Stimulsoft.Report.StiReport();
      // 加载文件
      report.load(body);
      //新建数据源
      var dataSet = new Stimulsoft.System.Data.DataSet("SimpleDataSet");
      //数据源填充数据
      delete data.printCount
      delete data.invoiceAddress
      dataSet.readJson(JSON.stringify(data));
      //给报表的数据源填充数据
      
      let hotelInfo = localStorage.getItem("hotelInfo") || "{}";
      hotelInfo = JSON.parse(hotelInfo);
      let storeName = hotelInfo.storeName || "云水荟";
      report.regData(dataSet.dataSetName, storeName, dataSet);
      var variableString = report.dictionary.variables.getByName("StoreName");
      variableString.value = storeName;
      if (num) {
        var printCount = report.dictionary.variables.getByName("printCount");
        printCount.value = num;
      }
      if(invoiceAddressValue){
        var invoiceAddress = report.dictionary.variables.getByName("invoiceAddress");
        invoiceAddress.value = invoiceAddressValue;
      }
      
      // report.regBusinessObject("StoreName", "酒店名称");
      // 创建报表
      viewer.report = report;
      this.loading = true;
      setTimeout(() => {
        that.loading = false;
      }, 1200);
      report.renderAsync( async function () {
        that.loading = false;
        await report.print();
      });
    },

  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.container {
  position: relative;
  height: 100%;
}

.content {
  align-items: center;
  justify-content: center;
  padding-top: 120px;

  .room-data{
    background: #D9ECFF;
    width: 80%;
    padding: 24px;

    .room-info{
      background: white;
      padding: 16px;

      .room-info-row{
        display: flex;
        height: 80px;
        color: #0a1929;
        font-size: 32px;
        padding-left: 128px;

        .room-info-label{
          color: #0a1929ad;
        }
      }
    }
  }

  .code-box {
    width: 850px;
    height: 950px;
    border-radius: 24px;

    .code {
      width: 850px;
      height: 850px;
      background-color: #fff;
      margin-bottom: 90px;
      border-radius: 8px;
      overflow: hidden;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .tip {
      font-weight: 600;
      font-size: 46px;
      color: #1A1E22;
    }
  }
}

.item {
  width: 858px;
  flex-flow: row;
  justify-content: space-around;
  margin: 8px;
}

.Key-card {
  position: absolute;
  z-index: -1;
}

.form{

  .form-content{
    padding: 48px;

    .guest-box {
      margin-top: 104px;
      width: 100%;
      .title {
        font-size: 40px;
        color: #1a1e22;
        margin-bottom: 32px;
        line-height: 50px;
        font-weight: 700;
        text-align: center;
      }
      .guest-sex {
        box-sizing: border-box;
        padding: 0 220px;
        margin-bottom: 45px;
        .sex-item {
          margin-bottom: 75px;
          .sex {
            img {
              width: 120px;
              height: 120px;
              margin-right: 16px;
            }
            span {
              font-size: 40px;
              color: #1a1e22;
              line-height: 50px;
            }
          }
          .num {
            img {
              width: 80px;
              height: 80px;
            }
            .number {
              font-size: 44px;
              color: #333333;
              font-weight: 700;
              width: 100px;
              line-height: 80px;
              text-align: center;
            }
          }
        }
      }
      .guest-type {
        width: 100%;
        box-sizing: border-box;
        padding: 0 220px;
        margin-bottom: 165px;
        select {
          width: 100%;
          height: 140px;
          background: #f4f4f4;
          box-shadow: inset 2px 4px 4px rgba(0, 0, 0, 0.25);
          border-radius: 16px;
          font-size: 44px;
          text-indent: 32px;
          color: #1a1e22;
          border: 0;
          &::placeholder {
            color: #b9bdc6;
          }
        }
      }
      .btn-group {
        width: 100%;
        box-sizing: border-box;
        padding: 0 105px;
        .btn-item {
          width: 392px;
          height: 140px;
          border-radius: 16px;
          background-color: #f4f4f4;
          font-size: 40px;
          color: #1a1e22;
          font-weight: 700;
          &.affirm {
            color: #fff;
            background-color: #155bd4;
          }
        }
      }
    }

  }

}

</style>